import * as R from 'ramda';
import { pipe } from 'fp-ts/lib/function.js';
import { map, all, any, equals, includes, isEmpty, isNil, reject, without, countBy, identity, } from 'ramda';
export const arraysEqualUnordered = (a, b) => equals(countBy(identity, a), countBy(identity, b));
export const anyIncludes = (string, list) => any((val) => includes(val, string), list);
export const anyIncludesC = (string) => (list) => anyIncludes(string, list);
export const anyEquals = (value, list) => list.some(equals(value));
export const anyEqualsC = (value) => (list) => anyEquals(value, list);
export const allEquals = (value, list) => list.every(equals(value));
export const allEqualsC = (value) => (list) => allEquals(value, list);
export const anyEqualsAny = (values, list) => list.some((listItem) => anyEquals(listItem, values));
export const anyEqualsAnyC = (values) => (list) => list.some((listItem) => anyEquals(listItem, values));
export const containsAnyC = (values) => (list) => list.some((listItem) => anyEquals(listItem, values));
export const propContainsAny = (prop) => (value) => (object) => {
    if (!object)
        return false;
    if (!value)
        return false;
    const propValue = object[prop];
    if (!propValue)
        return false;
    if (!Array.isArray(propValue))
        return false;
    return containsAnyC(value)(propValue);
};
export const last = (array) => array[array.length - 1];
export const propContainsC = (value) => (prop) => (object) => {
    if (!object)
        return false;
    if (!prop)
        return false;
    return !!object[prop]?.some(anyIncludesC(value));
};
export const propContainsAnyCC = (matching) => (prop) => (object) => {
    if (!object)
        return false;
    if (!prop)
        return false;
    return !!object[prop]?.some((property) => matching.some(anyIncludesC(property)));
};
export const propContainsAnyC = (prop, matching) => (object) => {
    if (!object)
        return false;
    if (!prop)
        return false;
    return !!object[prop]?.some((property) => matching.some(anyIncludesC(property)));
};
export const isDup = (list) => (element) => any(equals(element), list);
export const addOrRemove = (element, list) => {
    if (any(equals(element), list))
        return without([element], list);
    return [...list, element];
};
// `E` is the list's own element type, inferred from the list/contextual type.
// `NoInfer` keeps `element` from narrowing `E` — it only has to be a valid `E`.
export const addOrRemoveC = (element) => (list) => list.some((item) => equals(item, element))
    ? list.filter((item) => !equals(item, element))
    : [...list, element];
export const rejectEmpty = (list) => reject(isEmpty, list);
export const rejectNull = (list) => reject((item) => item === null, list);
export const rejectUndefined = (list) => reject((item) => typeof item === 'undefined', list);
export const rejectNil = (list) => reject(isNil, list);
export const rejectFalsy = (list) => reject((value) => (value === false ? true : !value), list);
export const onlyPopulatedValues = (list) => pipe(list, rejectNil, rejectEmpty);
export const exists = (item) => !isNil(item) && !isEmpty(item);
export const allElementsExist = (list = []) => pipe(list, map(Boolean), all(equals(true)));
export function getDotSeparatedKeys(obj, prefix = '') {
    return Object.entries(obj).flatMap(([key, value]) => {
        const fullKey = prefix ? `${prefix}.${key}` : key;
        if (value && typeof value === 'object' && !Array.isArray(value)) {
            return getDotSeparatedKeys(value, fullKey);
        }
        return fullKey;
    });
}
export function getAllStringValues(obj) {
    if (typeof obj === 'string')
        return [obj];
    if (typeof obj !== 'object' || obj === null)
        return [];
    return Object.values(obj).flatMap(getAllStringValues);
}
export const ensureIsArray = (value) => Array.isArray(value) ? value : [value];
/**
 *  If the array is NOT empty, this will call a function using that filled array as a param.
 *  Otherwise, it will return an empty array typed as whatever the return type of the function would be
 */
export const ifNotEmpty = (fn) => (data) => R.isNotEmpty(data) ? fn(data) : [];
// export const head = <T extends any>(list: T[]): T | undefined => list[0]
//# sourceMappingURL=arrays.js.map